/** English strings — shop simplification (docs/03 W4): card rarity, stat groups. */
export const enShop = {
  'cardrarity.common': 'COMMON',
  'cardrarity.uncommon': 'UNCOMMON',
  'cardrarity.rare': 'RARE',
  'cardrarity.epic': 'EPIC',
  'cardrarity.legendary': 'LEGENDARY',
  'cardrarity.mythic': 'MYTHIC',

  // SHIP STATUS groups (only modified stats are listed)
  'statp.group.offense': 'OFFENSE',
  'statp.group.defense': 'DEFENSE',
  'statp.group.mobility': 'MOBILITY',
  'statp.group.economy': 'ECONOMY',
  'statp.base': 'Stock ship — no upgrades yet',
} as const;
